export default __webpack_public_path__ + "static/trackthebat13-d8d68dc58f7a62c69e6d7833b84dd516.jpeg";